import {createGate} from "effector-react";
import {createEvent} from "effector";

export const LotsListGate = createGate()
export const SelectedLotGate = createGate()

export const closeLotEv = createEvent()

export const deleteLotsEv = createEvent()